<template>
  <div class="col">
    <label class="form-label">
      {{ props.showLabel ? '운수사' : '&nbsp;' }}
    </label>
    <div class="p-autocomplete-wrap">
      <AutoComplete
          v-model="selectedOfficeIpt"
          :suggestions="filteredOfficeNameList"
          @blur="handleOfficeBlur"
          @item-select="handleItemSelect"
          @complete="filterOffices"
          @show="handleDropdownShow"
          :inputProps="{
            onKeydown: handleKeydown,
          }"
          :auto-highlight="false"
          :auto-option-focus="false"
          emptySearchMessage="검색 결과가 없습니다."
          dropdown
      />
    </div>
  </div>
</template>

<script setup>
import {computed, defineProps, ref, watch} from "vue";
import {useStore} from "vuex";
import {searchBarProps} from "@/store/searchbar";
import {disassemble} from "es-hangul";

const emit = defineEmits(['loading']);
const props = defineProps({
  showLabel: {
    type: Boolean,
    default: true
  }
})
const store = useStore();
const patchSearchBar = (data) => store.dispatch('patchSearchBar', data);

// 변수
const selectedOffice = computed(() => store.state.searchBar.selectedOffice);
const officeList = computed(() => {
  const {searchBar} = store.state;

  return searchBar.allOffices;
});
const selectedOfficeIpt = ref(selectedOffice.value ? selectedOffice.value.displayName : '');
const filteredOfficeNameList = ref([]);


// Methods
function filterOffices(evt) {
  const query = evt.query.toLowerCase();
  const disassembledQuery = disassemble(query);
  filteredOfficeNameList.value = officeList.value.filter(item => {
      return !!(item.displayName.toLowerCase().includes(query)
          || item.disassembledName.includes(disassembledQuery));
    }).map(item => item.displayName);
}

function selectOfficeByDisplayName(nextOfficeDisplayName) {
  const targetOffice = officeList.value.find(item => item.displayName === nextOfficeDisplayName);
  if (!targetOffice) {
    return false;
  }

  selectedOfficeIpt.value = targetOffice.displayName;
  if (selectedOffice.value === targetOffice) {
    return true;
  }
  patchSearchBar({
    prop: searchBarProps.selectedOffice,
    value: targetOffice,
  });
}

function handleKeydown(evt) {
  if (evt.key !== 'Enter') {
    if (evt.key === 'ArrowDown') {
      evt.stopPropagation();
      evt.preventDefault();
    }
    return;
  }

  evt.stopPropagation();
  evt.preventDefault();
}

function handleOfficeBlur() {
  if (selectOfficeByDisplayName(selectedOfficeIpt.value) === true) {
    return;
  }

  selectedOfficeIpt.value = selectedOffice.value ? selectedOffice.value.displayName : '';
}

function handleDropdownShow(evt) {
  const targetEl = window.document.querySelector('.p-autocomplete-items .p-highlight');
  if (targetEl) {
    targetEl.scrollIntoView({block: 'center'});
  }
}

function handleItemSelect({value}) {
  selectOfficeByDisplayName(value);
}

watch(
    selectedOffice,
    (after, _) => {
      if (after && selectedOfficeIpt.value === after.displayName) {
        return;
      }

      selectedOfficeIpt.value = after && after.displayName ? after.displayName : '';
    }
);

</script>

<style scoped>
</style>
